module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro1-old.c25f7405.mp3";